import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { logout } from './authSlice';
 
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const baseQuery = fetchBaseQuery({
    baseUrl: BASE_URL, 
    credentials: 'include',
  });

  const baseQueryWithAuth = async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions);

    // console.log("API Response:", result);

    // Check if the error is due to an expired access token
    if (result.error && (result.error.status === 403 || result.error.status === 401)) {
        //console.warn("Access token expired or invalid. Attempting to refresh token...");

        // Attempt to refresh the access token
        const refreshResult = await baseQuery(
            { url: "/api/refresh-token", method: "POST", credentials: "include" },
            api,
            extraOptions
        );

       //console.log("Refresh Token Response:", refreshResult);

        if (refreshResult.data) {
            // Retry the original request with the new token
            result = await baseQuery(args, api, extraOptions);
        } else {
            // If refresh token fails, log out the user
            api.dispatch(logout());
        }
    }

    return result;
};

export const apiSlice = createApi({ 
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ( {
    getMe: builder.query({
        query: () => "/api/me",
    }),
  }),
});

export const { useGetMeQuery, useLazyGetMeQuery } = apiSlice;
export default apiSlice;